import { SelectionMenuViewMode } from '@components/ButtonBaseWithSelectionMenu/types/buttonBaseWithSelectionMenu.types';
import * as React from 'react';
import { useCallback } from 'react';
import ButtonBaseWithSelectionMenu from '../../../../../components/ButtonBaseWithSelectionMenu/ButtonBaseWithSelectionMenu';
import useWidth from '../../../../../components/Hooks/useWidth';
import { ESProductColor } from '../../../../products/ProductTypes';
import ColorElement from '../../../../products/colors/ColorElement';
import { useOrderContext } from '../../../contexts/Order.context';
import { ORDER_PRODUCT_SELECTION_MENU_CONFIG } from '../../orderProducts.constants';
import { OrderProductListViewType } from '../../orderProducts.types';
import OrderProductButtonContent from './OrderProductButtonContent';
import OrderProductColorMenu from './OrderProductColorMenu';

type OrderProductColorProps = {
  viewMode: OrderProductListViewType;
  currentColorId?: string;
  color: ESProductColor;
  productId?: string;
  disabled?: boolean;
  isLoadingButton?: boolean;
  onSelectNewColor?: (productColor: ESProductColor) => void;
};

const OrderProductColor = ({
  color,
  viewMode,
  productId,
  currentColorId,
  onSelectNewColor,
  disabled = false,
  isLoadingButton = true,
}: OrderProductColorProps) => {
  const { removeCopiedGrid } = useOrderContext();
  const { mobileWidth } = useWidth();

  const disabledButton = isLoadingButton || disabled || viewMode === SelectionMenuViewMode.VIEW;

  const orderEditPage = viewMode === SelectionMenuViewMode.EDIT;

  const handleSelectNewColor = useCallback(
    (newProductColor: ESProductColor) => {
      if (onSelectNewColor) {
        onSelectNewColor(newProductColor);
        removeCopiedGrid();
      }
    },
    [onSelectNewColor, removeCopiedGrid],
  );

  return (
    <ButtonBaseWithSelectionMenu
      viewMode={viewMode}
      disabled={disabledButton}
      isLoadingButton={isLoadingButton}
      menuConfig={ORDER_PRODUCT_SELECTION_MENU_CONFIG}
      disabledTooltipLabel={
        mobileWidth && viewMode === SelectionMenuViewMode.VIEW ? color.name : undefined
      }
      buttonContent={
        <OrderProductButtonContent
          disabled={disabledButton}
          prefix={color.code}
          label={color.name}
          startAdornment={
            <ColorElement
              size={1.75}
              isImage={color.isImage}
              hexcode={color.hexcode}
              imageUrl={color.imageUrl}
            />
          }
        />
      }
      renderMenuContent={({ closeMenu, anchorEl, updatePosition }) =>
        orderEditPage && !disabledButton && currentColorId ? (
          <OrderProductColorMenu
            anchorEl={anchorEl}
            updatePosition={updatePosition}
            productId={productId}
            currentColorId={currentColorId}
            onClick={(params) => {
              if (params.id !== currentColorId) {
                handleSelectNewColor(params);
              }

              closeMenu();
            }}
          />
        ) : null
      }
    />
  );
};

export default React.memo(OrderProductColor);
